import { createMD5 } from 'hash-wasm';
import { EventEmitter } from "events"

const fileSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
const chunkSize = 64 * 1024 * 1024; // 64MB

export class FileChecksum {
  static async create(file, callback) {
    const instance = new FileChecksum(file);
    await instance.create(callback);
  }

  constructor(file) {
    this.file = file;
    this.chunkSize = chunkSize; // 64MB
    this.chunkCount = Math.ceil(this.file.size / this.chunkSize);
    this.chunkIndex = 0;
    this.hasher = null;
    this.emitter = new EventEmitter()
  }

  async create(callback) {
    this.callback = callback;
    this.hasher = await createMD5();
    this.fileReader = new FileReader();
    this.fileReader.addEventListener("load", async (event) => await this.fileReaderDidLoad(event));
    this.fileReader.addEventListener("error", (event) => this.fileReaderDidError(event));
    this.readNextChunk();
  }

  hexStringToBase64(hexString) {
    if (hexString.length % 2 !== 0) {
      throw new Error('Hex string must have an even length');
    }

    const binaryString = Array.from(hexString.match(/.{2}/g))
      .map(byte => String.fromCharCode(parseInt(byte, 16)))
      .join('');

    return btoa(binaryString);
  }

  async fileReaderDidLoad(event) {
    const view = new Uint8Array(event.target.result);
    await this.hasher.update(view);

    this.emitter.emit('progress', {
      chunkIndex: this.chunkIndex,
      chunkCount: this.chunkCount,
      progress: this.chunkIndex / this.chunkCount
    });

    if (!this.readNextChunk()) {
      const hash = this.hasher.digest();
      const base64digest = this.hexStringToBase64(hash);
      this.callback(null, base64digest);
    }
  }


  fileReaderDidError(event) {
    console.error(`Error reading ${this.file.name}: ${event}`);
    this.callback(`Error reading ${this.file.name}`);
  }

  readNextChunk() {
    if (this.chunkIndex < this.chunkCount) {
      const start = this.chunkIndex * this.chunkSize;
      const end = Math.min(start + this.chunkSize, this.file.size);
      const chunk = fileSlice.call(this.file, start, end);
      this.chunkIndex++;
      this.fileReader.readAsArrayBuffer(chunk);
      return true;
    } else {
      return false;
    }
  }

  on(...args) {
    this.emitter.on(...args);
  }

  off(...args) {
    this.emitter.off(...args);
  }
}
